import { CommandPaletteButton } from '@/components/CommandPalette/CommandPaletteButton'
import { useOrgMetrics } from '@/hooks/useOrgMetrics'
import { usePhoneLineSummaryQuery } from '@/features/phone-lines/hooks/usePhoneLineSummaryQuery'

import { SectionCards } from './section-cards'

export function OrgHome() {
  const { data, isLoading, error } = useOrgMetrics()
  const { data: phoneLineSummary, isLoading: phoneLineLoading } =
    usePhoneLineSummaryQuery()

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="flex-1 min-h-0 overflow-auto px-6 py-4">
        <div className="flex flex-col justify-center min-h-full">
          <div className="w-full max-w-3xl mx-auto">
            <div className="mb-6 flex items-center justify-between gap-4">
              <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">
                Welcome back!
              </h1>
              <CommandPaletteButton />
            </div>

            {error ? (
              <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
                {error.message}
              </div>
            ) : (
              <SectionCards
                summary={data?.summary}
                ftwEstimate={data?.ftw_estimate}
                ftwPeriodStart={data?.ftw_period_start}
                isLoading={isLoading}
                phoneLineSummary={phoneLineSummary}
                phoneLineLoading={phoneLineLoading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
